// アイテムの色設定
export const ITEM_COLOR = { bg: '#3b82f6', border: '#2563eb' };
export const PERIOD_ITEM_COLOR = { bg: '#3b82f6', border: '#2563eb' };
export const POINT_ITEM_COLOR = { bg: '#f97316', border: '#ea580c' };

// 表示設定
export const MIN_WIDTH_FOR_TEXT = 60; // 文字表示の最小幅
export const MIN_DURATION_BAR_WIDTH_PX = 8; // 期間バーの最小幅
export const MAX_PERIODS_TO_SHOW = 15; // 表示可能な最大期間数
export const CONTAINER_WIDTH = 1200; // min-w-[1200px]
export const TIMELINE_MIN_SPAN_DAYS = 1;
export const TIMELINE_MAX_SPAN_YEARS = 200;
